/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PutConfigurationBody,
  GetConfigurationResponse,
  PutConfigurationResponse,
} from '../types';

export class ManagedConfigController extends Controller {
  async getConfiguration<T extends GetConfigurationResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/configuration',
      axiosConfig
    );
  }

  async putConfiguration<
    T extends PutConfigurationResponse,
    D,
    C extends PutConfigurationBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      '/configuration',
      body,
      axiosConfig
    );
  }
}
